import { DELAY } from "../helpers/_constants"

export function debounce(func: WatchCallback, timeout = DELAY.TWO_SECONDS): WatchCallback {
	let timer: ReturnType<typeof setTimeout>

	return function (...args: any[]) {
		clearTimeout(timer)
		timer = setTimeout(() => func(undefined, args), timeout)
	}
}

export function scrollToTop(top: number = 0) {
	window.scrollTo({ behavior: 'smooth', top })
}

export type WatchCallback<T = any> = (newValue?: T, oldValue?: T) => void
export type WatcherFunction = (element?: HTMLElement, eventName?: string) => void
